import React, { useEffect, useState } from "react";
import { Platform, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Divider } from "../../divider/Divider";
import { Radio } from "../../radio/Radio";
import { Button } from "../../button/Button";
// @ts-ignore
const CollateralLanguageFilter = ({ triggerAction, onBackPressAction, height, collateralData, onLanguageSelected, filtersSelected, counter, onResetFilterAction }) => {
    const [languageList, setLanguageList] = useState([]);
    const [languageSelected, setLanguageSelected] = useState([]);
    useEffect(() => {
        const languages = collateralData.map(item => item['language '].trim());
        setLanguageList(["All languages", ...new Set(languages)]);
    }, []);
    useEffect(() => {
        if (!filtersSelected || !Array.isArray(filtersSelected)) {
            setLanguageSelected(["All languages"]);
        }
        else if (Array.isArray(filtersSelected)) {
            if (!languageSelected.includes('All languages')) {
                setLanguageSelected((prevSelectedItems) => [
                    ...prevSelectedItems,
                    ...filtersSelected.filter((item) => !prevSelectedItems.includes(item)),
                ]);
            }
        }
    }, [filtersSelected, counter]);
    const headerView = () => {
        return (React.createElement(View, { style: styles.headerViewContainer },
            React.createElement(Typography, { label: "Filters", fontSize: FontSizeTokens.LG, fontWeight: "700", lineHeight: 26, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(TouchableOpacity, { onPress: () => {
                    triggerAction({
                        ...onBackPressAction
                    });
                } },
                React.createElement(Icon, { name: IconTokens.CrossIcon, size: IconSizeTokens.XXL }))));
    };
    const handleItemSelect = (itemId) => {
        const isSelected = languageSelected.includes(itemId);
        if (isSelected) {
            if (itemId === "All languages") {
                setLanguageSelected([itemId]);
            }
            else {
                setLanguageSelected((prevSelectedItems) => prevSelectedItems.filter((id) => id !== itemId && id !== "All languages"));
            }
        }
        else {
            if (itemId === "All languages") {
                setLanguageSelected([itemId]);
            }
            else {
                setLanguageSelected((prevSelectedItems) => prevSelectedItems.filter((id) => id !== itemId && id !== "All languages"));
            }
            setLanguageSelected((prevSelectedItems) => [...prevSelectedItems, itemId]);
        }
    };
    const onResetPress = () => {
        setLanguageSelected(["All languages"]);
    };
    const returnFilter = () => {
        return (React.createElement(TouchableOpacity, { style: {
                height: height - 114, zIndex: 1
            }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    height: height - 120
                } },
                React.createElement(View, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            } },
                            React.createElement(Typography, { label: "By language", fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: "500", color: ColorTokens.Primary_100 })),
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))),
                React.createElement(View, { style: {
                        width: 1,
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(ScrollView, { nestedScrollEnabled: true, contentContainerStyle: {
                        paddingBottom: Platform.OS !== 'web' ? 120 : 0
                    } }, languageList.map((item) => {
                    return (React.createElement(View, { style: {
                            flexDirection: 'column',
                            paddingLeft: 16,
                            paddingRight: 16,
                            paddingTop: 16,
                        } },
                        React.createElement(TouchableOpacity, { style: {
                                flexDirection: 'row',
                                alignContent: 'center',
                                alignItems: 'center',
                                height: 20,
                                zIndex: 1
                            }, onPress: () => {
                                handleItemSelect(item);
                            }, activeOpacity: 0.6 },
                            React.createElement(Radio, { isChecked: languageSelected.includes(item), onPressChecked: () => {
                                    handleItemSelect(item);
                                }, onPressUnChecked: () => {
                                    handleItemSelect(item);
                                } }),
                            React.createElement(View, { style: { marginLeft: 8 } },
                                React.createElement(Typography, { label: item, fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                        React.createElement(View, { style: { marginTop: 16 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))));
                })))));
    };
    return (React.createElement(View, { style: [styles.container, { height: height }] },
        headerView(),
        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
        returnFilter(),
        React.createElement(View, { style: {
                padding: 16,
                height: 56,
                position: "absolute",
                bottom: 0,
                flexDirection: 'row',
                backgroundColor: 'white',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.9,
                shadowRadius: 3,
            } },
            React.createElement(View, { style: { flex: 0.5, paddingLeft: 16, paddingTop: 16, paddingBottom: 16 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, onPress: () => {
                        onResetPress();
                    }, label: 'Reset filter', width: ButtonWidthTypeToken.FULL, height: 32, fontSize: FontSizeTokens.XS })),
            React.createElement(View, { style: { flex: 0.5, marginLeft: 12, paddingRight: 16, paddingTop: 16, paddingBottom: 16 } },
                React.createElement(Button, { onPress: () => {
                        triggerAction({
                            ...onLanguageSelected,
                            payload: {
                                value: languageSelected
                            }
                        });
                    }, label: 'Apply', type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, height: 32, fontSize: FontSizeTokens.XS })))));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    rowContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '75%',
    },
    headerViewContainer: {
        height: 60,
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16
    },
    columnContainer: {
        width: '100%',
        flexDirection: 'column',
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    bannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: "#F3F5FC",
        justifyContent: 'center',
        alignContent: 'center'
    },
    bannerTypeItemSeparator: {
        marginLeft: 12
    },
    collateralBanner: {
        height: 372,
        width: 304,
        marginTop: 24,
        marginRight: 24,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8,
        paddingBottom: 12,
        boxShadow: '0px 2px 5px rgba(9, 30, 66, 0.2)',
        marginBottom: 24,
        flexDirection: 'column',
        alignContent: 'center',
        alignSelf: 'center'
    },
    collateralBannerBottom: {
        height: 56,
        width: 304,
        position: 'absolute',
        bottom: 0,
        padding: 12,
        justifyContent: 'center',
        alignContent: 'center',
        backgroundColor: 'transparent',
    },
    collateralImage: {
        marginLeft: -4,
        marginTop: -4
    },
    collateralImageItemSeparator: {
        width: 24
    },
    downloadCTA: {
        paddingBottom: 12
    },
    selectedBannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: '#1434CB',
        justifyContent: 'center',
        alignContent: 'center'
    },
    collateralBannerList: {
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        marginRight: 4
    },
    filterView: {
        width: 66,
        height: 24,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'flex-end',
        marginRight: 40
    },
});
// @ts-ignore
export default (CollateralLanguageFilter);
